import React, { useState } from 'react'
import GiftList, { GiftListItems } from '../styles/giftList'
import { useHistory } from 'react-router-dom'
import GiftListHeader from './GiftListHeader'
import GiftListItem from './GiftListItem'

export default ({ items, title, collapsed, point, isPaid, isHome, isStore }) => {
  const history = useHistory()

  const [isListCollapsed, setListCollapsed] = useState(collapsed)

  const showGift = (id, purchaseDate) =>
    history.push(`/gift/${isPaid ? 'paid' : 'pay'}/${id}${purchaseDate ? '+' + purchaseDate : ''}`)

  const toggle = () => isListCollapsed != null && setListCollapsed(!isListCollapsed)

  const itemHeight = 72
  const itemMarginBottom = 7
  const listHeight = items.length * (itemHeight + itemMarginBottom)

  return (
    <GiftList>
      {title &&
        <GiftListHeader
          title={title}
          collapsed={isListCollapsed}
          onToggle={toggle}
        />
      }
      <GiftListItems collapsed={isListCollapsed} height={isStore && `${listHeight}px`}>
        {items && items.map((item, index) =>
          <GiftListItem
            height={`${itemHeight}px`}
            marginBottom={`${itemMarginBottom}px`}
            key={index}
            isDisabled={item.price > (point || 0)}
            isInvert={isHome}
            {...item}
            onClick={() => showGift(item.id, item.purchaseDate)}
          />
        )}
      </GiftListItems>
    </GiftList>
  )
}
